export class SetFileInfo {
    fileName = "";
    fileExists = false;
}
